"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.deleteDepsInRefToDepsMap = exports.depsToFnMap = exports.refToDepsMap = void 0;

require("core-js/modules/es.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.is.js");

require("core-js/modules/es.set.js");

var refToDepsMap = new Map();
exports.refToDepsMap = refToDepsMap;
var depsToFnMap = new Map();
exports.depsToFnMap = depsToFnMap;

var deleteDepsInRefToDepsMap = function deleteDepsInRefToDepsMap(targetDeps) {
  refToDepsMap.forEach(function (value, key) {
    value.delete(targetDeps);

    if (value.size === 0) {
      refToDepsMap.delete(key);
    }
  });
};

exports.deleteDepsInRefToDepsMap = deleteDepsInRefToDepsMap;

var unsubscribe = function unsubscribe(targetDeps, callback) {
  if (targetDeps === undefined && callback === undefined) {
    refToDepsMap.clear();
    depsToFnMap.clear();
    return;
  }

  if (!Object.is(targetDeps, undefined) && !Object.is(callback, undefined)) {
    var fns = depsToFnMap.get(targetDeps) || new Set();
    fns.delete(callback);

    if (fns.size !== 0) {
      return;
    }
  } else if (Object.is(targetDeps, undefined) && !Object.is(callback, undefined)) {
    console.warn('unsubscribe`s param: targetDeps, should not be undefined');
    return;
  }

  depsToFnMap.delete(targetDeps);
  deleteDepsInRefToDepsMap(targetDeps);
};

var _default = unsubscribe;
exports.default = _default;